var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { breakpointListener } from '../lib-breakpointListener';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var FooterContainer = /** @class */ (function (_super) {
    __extends(FooterContainer, _super);
    function FooterContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.writeState = componentApi.writeState.bind(_this);
        _this.removeBreakpointListener = function () { };
        _this.state = {};
        _this.state['_breakpoint'] = _this.props.breakpoint;
        return _this;
    }
    FooterContainer.prototype.render = function () {
        return (React.createElement("div", { "data-e2e": this.props.dataE2e, className: "cg-footer-container" },
            React.createElement("div", { role: !!this.props.srRole ? this.props.srRole : this.props.role, className: 'cg-footer-container-body ' +
                    (this.props.mode === 'workflow'
                        ? 'cg-footer-container-workflow '
                        : '') +
                    (this.props.mode === 'research'
                        ? 'cg-footer-container-research '
                        : '') +
                    (this.getBreakpoint() === 'M'
                        ? 'cg-footer-container-research-m '
                        : '') +
                    (this.getBreakpoint() === 'S'
                        ? 'cg-footer-container-research-s '
                        : '') +
                    (this.isStyleRow() ? 'cg-footer-container-row ' : '') }, this.props.children)));
    };
    FooterContainer.prototype.getBreakpoint = function () {
        if (this.props.breakpointControlMode === 'uncontrolled') {
            return this.state._breakpoint;
        }
        else {
            return this.props.breakpoint;
        }
    };
    FooterContainer.prototype.isStyleRow = function () {
        var breakpoint = this.getBreakpoint();
        if (this.props.mode === 'workflow') {
            return !(breakpoint === 'S' || breakpoint === 'XS');
        }
        if (this.props.mode === 'research') {
            return !(breakpoint === 'M' || breakpoint === 'S' || breakpoint === 'XS');
        }
    };
    FooterContainer.prototype.componentDidMount = function () {
        var _this = this;
        this.removeBreakpointListener();
        this.removeBreakpointListener = breakpointListener(function (breakpoint) {
            _this.writeState('_breakpoint', breakpoint);
        });
    };
    FooterContainer.prototype.componentWillUnmount = function () {
        this.removeBreakpointListener();
    };
    FooterContainer.defaultProps = {
        dataE2e: 'cg-footer-container',
        role: 'navigation',
        srRole: '',
        mode: 'workflow',
        breakpointControlMode: 'uncontrolled',
        breakpoint: 'L',
    };
    FooterContainer.displayName = 'FooterContainer';
    return FooterContainer;
}(React.Component));
export { FooterContainer };
